import request from '../utils/request';

// 创建陪逛地点
export const createLocation = (data) => {
  return request({
    url: '/accompany-shopping-location',
    method: 'post',
    data
  });
};

// 更新陪逛地点
export const updateLocation = (id, data) => {
  return request({
    url: `/accompany-shopping-location/${id}`,
    method: 'put',
    data
  });
};

// 删除陪逛地点
export const deleteLocation = (id) => {
  return request({
    url: `/accompany-shopping-location/${id}`,
    method: 'delete'
  });
};

// 分页查询陪逛地点
export const pageLocations = (params) => {
  return request({
    url: '/accompany-shopping-location/page',
    method: 'get',
    params
  });
};

// 获取陪逛地点详情
export const getLocationDetail = (id) => {
  return request({
    url: `/accompany-shopping-location/${id}`,
    method: 'get'
  });
};
